import { FC, useCallback } from "react";
import { ChartSeriesSelect } from "@/storybook/c8r-highcharts/common/components/ChartSeriesSelect";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { billingExplorerSetupVisualizationPropertyByKeySelector } from "@/store/dashboards/selectors/setups/billing-explorer/billingExplorerSetupVisualizationPropertyByKeySelector";
import { billingExplorerViewVisualizationChangeThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/setup-change/billingExplorerViewVisualizationChangeThunk";
import { getBillingExplorerWidgetSetupDataThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/getBillingExplorerWidgetSetupDataThunk";

export const BillingExplorerWidgetVisualizationSeries: FC = () => {
  const dispatch = useAppDispatch();
  const series: number =
    useAppSelector(
      billingExplorerSetupVisualizationPropertyByKeySelector("series"),
    ) ?? 10;

  const changeHandler = useCallback(
    (series: number) => {
      dispatch(
        billingExplorerViewVisualizationChangeThunk({
          series,
        }),
      );
      dispatch(getBillingExplorerWidgetSetupDataThunk());
    },
    [dispatch],
  );

  return <ChartSeriesSelect series={series} onSeriesChange={changeHandler} />;
};
